import React, { useContext } from 'react'
import { Spinner } from 'react-bootstrap'
import { AuthContext } from '../Auth/AuthContext'
import "./Loading.css"

function Loading(props) {
    const authCx = useContext(AuthContext)

    return (
        <div id="loading">
            <div className="content"
            style={{
                top: authCx.isAuth ? "40%": "50%",
                left: authCx.isAuth ? "40%": "50%"
            }}
            >
                <Spinner 
                variant="primary" 
                animation="border" 
                className="spinner"/>
                <div className="title">
                    {props.title}
                </div>
            </div>
        </div>
    )
}

export default Loading
